<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  priority: { type: String, default: 'normal' },
});

const badgeClass = computed(() => {
  const classes = {
    low: 'bg-slate-100 text-slate-700 dark:bg-n-alpha-2 dark:text-n-slate-11',
    normal: 'bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300',
    high: 'bg-amber-100 text-amber-800 dark:bg-amber-500/10 dark:text-amber-300',
    urgent: 'bg-rose-100 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300',
  };

  return classes[props.priority] || 'bg-n-alpha-2 text-n-slate-11';
});
</script>

<template>
  <span
    class="shrink-0 rounded-full px-2 py-1 text-[11px] uppercase"
    :class="badgeClass"
  >
    {{ label }}
  </span>
</template>
